const normalizePaymentMethodKind = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const isNativeCreditIdentifier = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  const normalized = normalizePaymentMethodKind(value);
  return (
    raw === "credit" ||
    normalized === "a-credit" ||
    normalized === "customer-credit"
  );
};

const isCreditPaymentMethod = (method) => {
  if (method && typeof method === "object") {
    // Un identifiant stable prime toujours sur le libellé. REX possède par
    // exemple un moyen encaissé `cdr` nommé « Crédit » qui n'est pas le
    // reliquat client natif de MOO Sync.
    const identifiers = [method.code, method.key, method.method].filter(
      (value) => String(value || "").trim(),
    );
    if (identifiers.length > 0) {
      return identifiers.some(isNativeCreditIdentifier);
    }
    // Les anciens rapports ne transportaient que le libellé. Le libellé
    // réservé au crédit natif est « À crédit », jamais « Crédit » seul.
    return normalizePaymentMethodKind(method.name) === "a-credit";
  }
  return isNativeCreditIdentifier(method);
};

module.exports = { isCreditPaymentMethod, normalizePaymentMethodKind };
